<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $t("weekends") }}</div>
      <div>
        <router-link class="btn-blue" to="weekends"
          >{{ $t("weekends") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0">{{
                msgcinema
              }}</span>
            </p>
            <br />
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row">
          <b-form-checkbox
            v-for="(weekdaysLoop, weekdaysKey) in weekDays"
            :key="weekdaysKey"
            class="j-checkbox mr-3 mb-3"
            @change="OnSelectWeekends($event, weekdaysKey)"
            v-model="weekDays[weekdaysKey]"
          >
            <div class="text-capitalize">{{ weekdaysKey }}</div>
          </b-form-checkbox>
        </div>
        <p class="error_message">
          <span v-if="submitted">{{ msgweek }}</span>
        </p>
        <br />
      </div>

      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="row">
          <div class="col-md-3 col-xl-2">
            <label>{{ $t("active") }}</label>
          </div>
          <div class="col-md-9 col-xl-10">
            <div class="col-4">
              <b-form-checkbox
                v-model="isActive"
                unchecked-value="N"
                value="Y"
                switch
                class="j-checkbox"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
        <p class="error_message">
          <span></span>
        </p>
      </div>

      <div class="col-md-12 text-center mt-4">
        <button
          :disabled="btenable"
          @click.prevent.stop="OnSubmit()"
          class="btn-blue"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      CinemasListCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      submitted: false,
      msgcinema: "",
      msgweek: "",
      selectedCinema: "",
      cineid: "",
      CinemasList: [],
      weekDays: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },
      isActive: "Y",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getAllActiveCinemas(obj);
    } else {
      this.getAllActiveCinemas(obj);
    }
  },
  methods: {
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.CinemasList = this.CinemasListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CinemasList = this.CinemasListCopy;
      }
    },
    ResetForm: function () {
      this.weekDays = {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      };
      this.selectedCinema = "";
    },
    getAllActiveCinemas: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
            this.CinemasListCopy = data.Records;
            this.CinemasList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };
                this.onSelectCinema(event, cinema);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
        });
    },

    onSelectCinema: function (event, cinema) {
      this.selectedCinema = cinema.cine_name;
      this.cineid = cinema.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
    },

    OnSelectWeekends: function (event, days) {
      this.weekDays;
      this.msgweek = "";
    },

    OnSubmit: function () {
      this.submitted = true;
      let weekarr = Object.keys(this.weekDays).filter((x) => this.weekDays[x]);
      console.log("weekarr :", weekarr);

      this.$validator.validate().then((valid) => {
        if (this.selectedCinema.length == 0) {
          this.msgcinema = "Please Select Cinema.";
          return this.msgcinema;
        } else if (weekarr.length === 0) {
          return (this.msgweek = "Please Select at least One Weekend Day.");
        } else {
          this.btenable = true;
          let payload = {
            cine: this.cineid,
            weekday: this.weekDays,
            active: this.isActive,
          };
          // console.log("payload :", payload);
          MasterService.AddWeekends(payload)
            .then((response) => {
              this.btenable = false;
              console.log("response :", response);
              const { data } = response;

              if (data.status) {
                this.ResetForm();

                this.$router.push({
                  path: "/cinema-manager/weekends",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/WeekendsComponents/addWeekends.vue